/**
 * The analysis notice's wording (docs/plans/live-working-layer.md §2.17). Pure.
 *
 * Says nothing while the analysis is current; once it is behind, when it was built and
 * what has changed since, e.g. "Analysis built 5 Oct, 14:02 · since then: 12 answers
 * changed, 1 statement changed".
 */

const count = (n, one, many) => `${n.toLocaleString('en-GB')} ${n === 1 ? one : many}`

export function builtAt(value) {
    if (!value) return ''

    const date = new Date(value)

    return `${date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}, ${date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`
}

/** The notice, or null when there is nothing to say. */
export function analysisNotice(status) {
    if (!status?.behind) return null
    if (!status.built_at) return 'Analysis not built yet'

    const changes = [
        status.answers_changed ? count(status.answers_changed, 'answer', 'answers') : '',
        status.statements_changed ? count(status.statements_changed, 'statement', 'statements') : '',
        status.rates_changed ? count(status.rates_changed, 'rate', 'rates') : '',
    ].filter(Boolean)

    return `Analysis built ${builtAt(status.built_at)} · since then: ${changes.join(', ')} changed`
}
